<div class="modal-top">
  <h1 mat-dialog-title>
    <i
      *ngIf="showTicket"
      class="fa fa-ticket ticketIcon"
      aria-hidden="true"
    ></i>
    {{ title }}
  </h1>
  <button
    mat-dialog-close
    type="button"
    class="closeBtn"
    aria-label="Close dialog"
    #closeBtn
  >
    <i class="fa fa-times" aria-hidden="true"></i>
  </button>
</div>
